import React from 'react';
import { useTranslation } from 'react-i18next';

import Ball from './Ball';

type Props = {
    readonly pool: number;
    readonly length: number;
    readonly number: number | null;
    readonly updateValueInNewLine: Function;
};

function BallList({ pool, length, number, updateValueInNewLine }: Props) {
    const { t } = useTranslation();

    function getContent() {
        return (
            <div key={pool} className="row flex-column flex-md-row">
                <div className="col-auto col-md-3 col-lg-2 text-center text-md-left">
                    <p className="mt-4">{t(`playPicker.nNumber.${pool}`)}</p>
                </div>
                <div className="col px-0">
                    <div className="row row-numbers no-gutters purchase-line-numbers justify-content-center play-balls-row">
                        {[...Array(length)].map((j, value) => {
                            return (
                                <Ball
                                    key={value}
                                    pool={pool}
                                    value={value}
                                    onBallClick={updateValueInNewLine}
                                    selected={number === value}
                                />
                            );
                        })}
                    </div>
                </div>
            </div>
        );
    }

    return getContent();
}

export default BallList;
